import { IconButton, Menu, MenuItem } from '@material-ui/core';
import { MoreVert } from '@material-ui/icons';
import React, { ReactNode, useState } from 'react';
import ConfirmationDialog from '../ConfirmationDialog';

interface Props {
  loading?: boolean;
  canEdit?: boolean;
  canDelete?: boolean;
  shouldConfirmDelete?: boolean;
  text: {
    edit: ReactNode;
    delete: ReactNode;
    dialogTitle: string;
    dialogText: string;
  };
  testIds: {
    kebab: string;
    menu: string;
  };
  handlers: {
    edit(): unknown;
    delete(): unknown;
  };
}

export function CommentActions({
  loading = false,
  canEdit = false,
  canDelete = false,
  shouldConfirmDelete = true,
  text,
  testIds,
  handlers,
}: Props) {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [showingDeleteDialog, setShowingDeleteDialog] = useState(false);

  function showMenu(atElement: HTMLElement) {
    return setAnchorEl(atElement);
  }

  function hideMenu() {
    return setAnchorEl(null);
  }

  function editComment() {
    hideMenu();
    return handlers.edit();
  }

  function showDeleteDialog() {
    hideMenu();
    return setShowingDeleteDialog(true);
  }

  function hideDeleteDialog() {
    return setShowingDeleteDialog(false);
  }

  function confirmDelete() {
    hideDeleteDialog();
    return handlers.delete();
  }

  return (
    <>
      <IconButton onClick={(event) => showMenu(event.currentTarget)} data-testid={testIds.kebab}>
        <MoreVert />
      </IconButton>
      <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={hideMenu} data-testid={testIds.menu}>
        {canEdit && <MenuItem onClick={editComment}>{text.edit}</MenuItem>}
        {canDelete && (
          <MenuItem onClick={shouldConfirmDelete ? showDeleteDialog : confirmDelete}>{text.delete}</MenuItem>
        )}
      </Menu>
      {showingDeleteDialog && shouldConfirmDelete && (
        <ConfirmationDialog
          open={true}
          loading={loading}
          onConfirm={confirmDelete}
          onClose={hideDeleteDialog}
          dialogTitle={text.dialogTitle}
          dialogText={text.dialogText}
        />
      )}
    </>
  );
}
